import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { ProductService } from '../services/product.api.service';

export const configurationFieldNamesTranslationGuard: CanActivateFn = async () => {
	const router = inject(Router);
	const productService = inject(ProductService);
	try {
		await firstValueFrom(productService.loadConfigurationFieldNames());
		return true;
	} catch (err) {
		console.error('unable to load configuration field names', err);
		return router.createUrlTree(['/']);
	}
};
